import { Analytics } from 'Shared/utils/client';
import type { ModalProps } from '@viewup/ui';
import { Button, CheckFill, Column, Modal, Row, TextField, Typography } from '@viewup/ui';
import { useGlobalModalStore } from 'app/_hook';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { kakaoScript, shareButtons } from './ShareModal.const';

interface ShareModalProps extends Pick<ModalProps, 'exitHandler'> {}

export const ShareModal = (props: ShareModalProps) => {
  const { exitHandler } = props;
  const pathname = usePathname();

  const { getValue } = useGlobalModalStore();
  const { setAlertModal } = getValue('actions');

  useEffect(() => {
    kakaoScript('https://t1.kakaocdn.net/kakao_js_sdk/2.3.0/kakao.min.js');
  }, []);

  const copyNoticePageLink = () => {
    if (window.app) {
      exitHandler();
      setAlertModal({
        content: '복사되었어요.',
        hasIcon: true,
        iconSource: CheckFill,
      });
      window.app?.copyToClipboard(window.location.href);
      return;
    }

    navigator.clipboard.writeText(window.location.href).then(() => {
      exitHandler();
      setAlertModal({
        content: '복사되었어요.',
        hasIcon: true,
        iconSource: CheckFill,
      });
    });
  };

  return (
    <Modal
      exitHandler={exitHandler}
      isOpen={true}
      styledComponents={{
        title: { css: { textAlign: 'center' }, mb: 24 },
      }}
      title={'공유하기'}
    >
      <Column gap={24}>
        {/* 각 sns 공유하기 버튼 */}
        <Row gap={16} justifyContent='space-between'>
          {shareButtons.map((shareButton) => (
            <Column
              alignItems='center'
              css={{
                cursor: 'pointer',
              }}
              gap={8}
              justifyContent='center'
              key={shareButton.title}
              onClick={() => {
                Analytics.getInstance().track('SHARE_PLATFORM', {
                  pageName: pathname.split('/')[1],
                  platform: shareButton.platform,
                });
                shareButton.onClick();
              }}
            >
              {shareButton.image}
              <Typography color='text.tertiary' fontType='body2.regular'>
                {shareButton.title}
              </Typography>
            </Column>
          ))}
        </Row>

        {/* 링크복사 버튼 */}
        <Row alignItems='center' gap={8}>
          <TextField
            disabled
            styledComponents={{
              inputProps: {
                css: {
                  textOverflow: 'ellipsis',
                },
              },
            }}
            value={location.href}
          />
          <Button onClick={copyNoticePageLink} size='XS' variant='ghost.primary'>
            링크복사
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};
